import { CustomLink } from "../components/CustomLink";
import { PageCard, PageShell } from "../components/ui";
import { useTranslation } from "react-i18next";

const Notfoundpage = () => {
    const { t } = useTranslation();

    return (
        <PageShell>
            <PageCard className="p-6 sm:p-10">
                <div className="mx-auto max-w-lg text-center">
                    <p className="m-0 text-sm font-semibold text-[#1D2C7B]">{t('notfound.code')}</p>
                    <h1 className="mt-2 text-xl font-semibold text-slate-800 sm:text-2xl">
                        {t('notfound.title')}
                    </h1>
                    <p className="mt-2 text-sm text-slate-500">
                        {t('notfound.text')}
                    </p>
                    <CustomLink to="/">
                        <span className="mt-5 inline-flex h-10 items-center rounded-lg bg-[#1D2C7B] px-5 text-sm font-semibold text-white">
                            {t('notfound.home')}
                        </span>
                    </CustomLink>
                </div>
            </PageCard>
        </PageShell>
    );
};

export { Notfoundpage };
